/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * toastStore.ts — toas\1 \2tore (services/operator-web-app).
 */

/**
 * E3-S3 T3: Simple toast notifications for call/voice feedback.
 * Auto-dismiss after TOAST_TTL_MS; ToastContainer renders in layout.
 */
import { createStore } from 'zustand';

const TOAST_TTL_MS = 4000;
const MAX_TOASTS = 5;

export type ToastVariant = 'info' | 'success' | 'error' | 'warning';

export interface Toast {
  id: string;
  message: string;
  variant: ToastVariant;
  createdAt: number;
}

interface ToastState {
  toasts: Toast[];
  addToast: (message: string, variant?: ToastVariant) => void;
  removeToast: (id: string) => void;
}

function generateId(): string {
  return `toast-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

export const toastStore = createStore<ToastState>((set) => ({
  toasts: [],

  addToast: (message: string, variant: ToastVariant = 'info') => {
    const id = generateId();
    const createdAt = Date.now();
    set((prev) => ({
      toasts: [...prev.toasts, { id, message, variant, createdAt }].slice(-MAX_TOASTS),
    }));
    setTimeout(() => toastStore.getState().removeToast(id), TOAST_TTL_MS);
  },

  removeToast: (id: string) => {
    set((prev) => ({
      toasts: prev.toasts.filter((t) => t.id !== id),
    }));
  },
}));

export function addToast(message: string, variant?: ToastVariant): void {
  toastStore.getState().addToast(message, variant);
}
